// extracted by mini-css-extract-plugin
module.exports = {"Feedback":"Feedback_Feedback__17SyA","FeedbackLabel":"Feedback_FeedbackLabel__6IqRs","FeedbackForm":"Feedback_FeedbackForm__ZjaBd","ButtonWrap":"Feedback_ButtonWrap__St5Hu"};